<template>
  <div class="list">
    <div class="item" v-for="(item, i) in list" :key="i" @click="$router.push({ path: '/classDetail', query: {id: item.id} })">
      <div class="left">
        <img :src="item.pictureUrl" alt="">
      </div>
      <div class="right">
        <div class="title">{{item.name}}</div>
        <ul>
          <li class="w140">
              <img src="@/assets/images/face-icon-1.png" alt="">
              <span>学时：{{item.period}}学时</span>
          </li>
          <li class="w440">
              <img src="@/assets/images/face-icon-2.png" alt="">
              <span>包含课程：{{(item.courseNumber || 0) + (item.trainNumber || 0) + `门(${item.courseNumber || 0}门课程/${item.trainNumber || 0}门实训)`}}</span>
          </li>
          <li>
              <img src="@/assets/images/face-icon-3.png" alt="">
              <span>开班时间：{{ item.openStartTime ? item.openStartTime.split(' ')[0] : '' }} 至 {{ item.openEndTime ? item.openEndTime.split(' ')[0] : '' }}</span>
          </li>
          <li>
              <img src="@/assets/images/face-icon-4.png" alt="">
              <span>培训地点：{{ item.address }}</span>
          </li>
          <li class="pxdx">
              <img src="@/assets/images/face-icon-5.png" alt="">
              <el-tooltip effect="dark" :open-delay="200" placement="top">
                <div slot="content" class="tooltip-text">{{ item.trainObject }}</div>
                <span class="not">
                  <span>培训对象：{{ item.trainObject }}</span>
                  <span v-if="item.trainObject && item.trainObject.length >= 44" class="not tips-inidex">【查看更多】</span>
                </span>
              </el-tooltip>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faceList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.item{
  display: flex;
  padding: 30px 23px;
  border-bottom: 2px dashed #DCDCDC;
  cursor: pointer;
  margin: 0 30px;
  &:hover{
    background: #F2F2F2;
  }
  .left{
    width: 220px;
    height: 120px;
    margin-right: 25px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .right{
    flex: 1;
    .title{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin-bottom: 4px;
    }
    ul{
      li{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        img{
          width: 14px;
          vertical-align: middle;
        }
        span{
          vertical-align: middle;
          padding-left: 3px;
        }
        &.w140{
          width: 140px;
          display: inline-block;
        }
        &.w440{
          width: 440px;
          display: inline-block;
        }
        &.pxdx{
          width: 800px;
          span:not(.not) {
            max-width: 86%;
            display: inline-block;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }
          .tips-inidex {
            color: #456DEC;
          }
        }
      }
    }
  }
}
</style>
